module.exports = __webpack_public_path__ + "woman-writing-on-a-notebook-beside-teacup-and-tablet-733856.jpg";